const getters = {
  menus: state => state.user.menus,
  permissionRoutes: state => state.permission.addRoutes,
  token: state => state.user.token,
  accessEntrance: state => state.user.accessEntrance
}

export default getters
